/**
 * 将日期时间戳进行格式化
 *
 * @param {Date} time 日期
 * @param {String} cFormat 格式化
 *
 * e.g. parseTime(new Date*1)
 *   ==> 2018-01-30 18:52:39
 *
 *  parseTime(new Date*1, '{y}-{m}-{d} 星期 {a}')
 *   ==> 2018-01-30 星期二
 *
 */
export function parseTime(time, cFormat) {
  if (!time) {
    return ''
  }

  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'

  let date = null
  date = typeof time === 'object' ? time : new Date(parseInt(time))
  if (typeof time === 'string') {
    // const t = time.replace(/-/g, '/') // ie浏览器不认2020-20-20这种，=>2020/20/20这种
    date = new Date(time)
    if (date.toString() === 'Invalid Date') {
      // 再尝试ie浏览器不认2020-20-20这种，=>2020/20/20这种
      const t = time.replace(/-/g, '/')
      date = new Date(t)
      if (date.toString() === 'Invalid Date') {
        return time
      }
      // return time
    }
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay()
  }
  const timeStr = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') return ['一', '二', '三', '四', '五', '六', '日'][value - 1]
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
  return timeStr
}

/**
 * 将 1,234 这种形式的 数字字符串转为 数值类型
 *
 * e.g. numberFormat('1,234') => 1234
 *
 * @param {String} numberString 数值字符串
 */
export function numberFormat(numberString) {
  numberString = '' + numberString
  numberString = numberString.replace(/,/g, '')
  return +numberString
}

/**
 * 将数字转千分位表示
 * */
export function parseToThousandth(number) {
  number = '' + number
  return number.replace(/(\d)(?=(\d{3})+(\.|$))/g, '$1,')
}

// 过滤前后空格
export function replaceSpace(text) {
  return text.replace(/(^\s*)|(\s*$)/g, '') // 过滤掉前后空格
}

/**
 * 过滤字符串中含有的html标签
 * @param {String} str 原始字符串
 *
 * 在取值时 非字符串类型 时,进行特殊处理
 * 数据为 null, '' 时 返回 ''
 */
export function filterHTMLTag(str) {
  if (typeof str === 'number' || typeof str === 'boolean' || typeof str === 'function') {
    str = '' + str
  }
  return str ? str.replace(/<[^>]+>/gm, '') : ''
}

// 返回相对于根目录的绝对路径
// 环境不一样，有些部署于根目录，有些部署于子目录
export function fillPublicPath(path) {
  const serverPath = process.env.BASE_URL + path
  return serverPath.replace('//', '/')
}

export function fillMsServerPath(src) {
  const serverPath = window.APP_CONFIG.BASE_URL || process.env.VUE_APP_BASE_URL
  return serverPath + src
}
